(ns hai.contacts.routes
  (:require
   [hai.contacts.detail :as detail]
   [hai.contacts.eql :as eql]
   [hai.contacts.page :as page]
   [hai.ui.icons :as icons]
   [hai.ui.rf-sugar :refer [>e]]
   [hai.web-app.routing :as routing]))

(defn routes
  []
  [["/contacts"
    {::routing/window-title "Contacts"
     :label/short "Contacts"
     :icon icons/humble-contact}
    ["" {:name        :contacts/view
         :label       "Contacts"
         :breadcrumbs ["Contacts"]
         :view        page/page}]
    ["/{contact/uuid}"
     {:name :contacts/detail
      ::routing/window-title ::detail/window-title
      :breadcrumbs [:contacts/view "Contact"]
      :view detail/page
      :controllers [{:parameters {:path [:contact/uuid]}
                     :start (fn [{path :path}]
                              (>e [:entity/resolve path
                                   {;; The same shape the editor's other hosts
                                    ;; resolve, so a contact is one thing
                                    ;; wherever it is opened.
                                    :pattern       eql/contact-eql
                                    ;; The composer's draft is seeded from the
                                    ;; contact the resolve just stored — the
                                    ;; page renders once it is there.
                                    :on-success-fx [[:dispatch [::detail/mark-resolved (:contact/uuid path)]]
                                                    [:dispatch [::detail/seed-draft (:contact/uuid path)]]]
                                    :on-error-fx   [[:dispatch [::detail/mark-resolved (:contact/uuid path)]]]}]))
                     :stop (fn [{path :path}]
                             (>e [::detail/discard-draft (:contact/uuid path)]))}]}]]])
